// ============================================================
// TaskFlow OS - Main Layout
// ============================================================

import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const MainLayout: React.FC = () => {
  return (
    <div className="flex min-h-screen">
      {/* Background particles */}
      <div className="bg-particles" />

      {/* Sidebar */}
      <Sidebar />

      {/* Main content */}
      <main className="flex-1 flex flex-col min-h-screen relative z-10 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
